var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-chebox--label-container",class:{'flip-chebox--label-container__reverse': _vm.right},on:{"click":_vm.changeCheck}},[_c('div',{staticClass:"flip-chebox--container",class:{
         'flip-chebox--container__radio': _vm.radio,
         'flip-chebox--container__outlined': _vm.outlined,
         [_vm.componeBorderColor(_vm.color_true)]: _vm.check,
         [_vm.componeBorderColor(_vm.color_false)]: !_vm.check,
      },style:('transform: translateY(-4px) scale(' + _vm.scale + ')')},[_c('div',{staticClass:"flip-chebox",class:{
            'no_animation': !_vm.delay_mounted_1000,
            'flip-chebox__true': _vm.check,
            'flip-chebox__false': !_vm.check,
            'flip-chebox__outlined': _vm.outlined,
         }},[_c('div',{staticClass:"flip-chebox--face flip-chebox--true"},[_c('v-icon',{attrs:{"small":_vm.outlined,"color":_vm.color_true}},[_vm._v(" mdi-"+_vm._s(_vm.icon_true)+" ")])],1),_c('div',{staticClass:"flip-chebox--face flip-chebox--false"},[_c('v-icon',{attrs:{"small":_vm.outlined,"color":_vm.color_false}},[_vm._v(" mdi-"+_vm._s(_vm.icon_false)+" ")])],1)])]),_c('div',{staticClass:"flip-chebox--label",class:{
         ['!text-' + (!_vm.disable_text_color ? _vm.color_true : '')]: _vm.check,
         ['!text-' + (!_vm.disable_text_color ? _vm.color_false : '')]: !_vm.check,
      },domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }